import React from 'react';
import {
    Card,
    AdvancedTable,
    AdvancedTableHeader,
    AdvancedTableData,
    AppType,
} from 'components';
import { IExamExpert } from 'components/models';
import { formatPhoneNumber } from '_helpers';
import expertIcon from 'components/assets/svg/empty_expert_table.svg';

const ExpertsTab = ({ experts: propsExperts, handleExpertClick, appType }: IProps) => {
    const [experts, setExperts] = React.useState(propsExperts);
    const isQec = appType === AppType.Qec;
    const isApplicant = appType === AppType.Applicant;

    const roleOptions = [
        {
            label: 'Все',
            value: 'undefined',
        },
        {
            label: 'Председатель комиссии',
            value: 'true',
        },
        {
            label: 'Член комиссии',
            value: 'false',
        },
    ];

    const createTableHeaders = () => {
        const tableHeaders: AdvancedTableHeader[] = [
            { fieldName: 'fullName', title: 'ФАМИЛИЯ, ИМЯ, ОТЧЕСТВО' },
            { fieldName: 'chairman', title: 'РОЛЬ ЭКСПЕРТА', selectOptions: roleOptions },
            // { fieldName: 'region', title: 'СТАТУС', selectOptions: roleOptions },
        ];

        if (!isApplicant) {
            tableHeaders.splice(1, 0, { fieldName: 'phone', title: 'ТЕЛЕФОН' });
        }

        if (isQec) {
            tableHeaders.splice(2, 0, { fieldName: 'email', title: 'ПОЧТА' });
        }

        return tableHeaders;
    };

    const handleSearch = (fieldName: string, value: string) => {
        const key = fieldName as keyof IExamExpert;
        const val = value.toLocaleLowerCase();
        const newExperts = [...propsExperts];

        if (key === 'chairman') {
            if (val === 'undefined') {
                setExperts(propsExperts);
            } else {
                setExperts([
                    ...newExperts.filter(exp => (val === 'true' ? exp.chairman : !exp.chairman)),
                ]);
            }
        } else if (val) {
            setExperts([
                ...newExperts.filter(exp => ((exp[key] || '') as string).toLocaleLowerCase().includes(val)),
            ]);
        } else {
            setExperts(propsExperts);
        }
    };

    const createTableData = (): AdvancedTableData[] => experts.map((item) => {
        const columns = [item.fullName, item.chairman ? 'Председатель комиссии' : 'Член комиссии'];

        if (!isApplicant) {
            columns.splice(1, 0, formatPhoneNumber(item.phone) || item.phone);
        }

        if (isQec) {
            columns.splice(2, 0, item.email);
        }

        return ({
            id: item.expertId,
            columns,
        });
    });

    const onRowClick = (id: string) => {
        if (handleExpertClick) {
            handleExpertClick(id);
        }
    };

    return (
        <Card
          title="Экспертная комиссия"
          category="Список членов экспертной комиссии"
          withoutPadding
          withoutBorder
        >
            <AdvancedTable
              data={createTableData()}
              tableHeaders={createTableHeaders()}
              handleRowClick={onRowClick}
              handleSearch={handleSearch}
              placeholderTitle="Эксперты не найдены"
              placeholderText="Пожалуйста, убедитесь, что запрос введен правильно"
              placeholderIcon={expertIcon}
            />
        </Card>
    );
};

export default ExpertsTab;

interface IProps {
    experts: IExamExpert[];
    appType: AppType;
    handleExpertClick?: (expertId: string) => void;
}
